<template>
  <Toaster/>
  <div class="container-fluid">
    <div class="alert alert-info">Found total of {{ totalStructures }} structures in PLIC folder</div>
  </div>
  <StructureInfo v-for="structure in structures" :key="structure.id || structure.pdb" :structure="structure"
                 @update-description="(description) => structure.description = description"
                 @update-pubmed-id="(pubmedId) => structure.pubmedId = pubmedId"
                 @update-id="(id) => structure.id = id"
                 @set-loaded-status="(status) => structure.alreadyLoaded = status"
                 @update-tags="(tags) => structure.tags = tags"
                 @update-sequence="(sequence) => structure.sequence = sequence"
                 @update-protein-id="(proteinId) => structure.proteinId = proteinId"
                 @toast-success="(message) => makeToast(message)"
  >
  </StructureInfo>
  <div v-if="!hydrated" class="text-center">
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div class="container-fluid mt-5">
    <div class="input-group mb-3">
      <input class="form-control" type="text" v-model="confirmationCode">
      <button class="btn btn-danger input-group-addon" @click="clean">Reset</button>
    </div>
  </div>
</template>

<script>
import StructureInfo from "./admin/StructureInfo.vue";
import axios from "axios";
import {toast, Toaster} from 'vue-sonner'

let start = 0;
const batchSize = 10;

export default {
  name: "Admin",
  data() {
    return {
      structures: [],
      hydrated: false,
      totalStructures: 0,
      confirmationCode: ''
    }
  },
  components: {
    Toaster,
    StructureInfo
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      axios.get('/api/admin/structures/count').then(response => {
        this.totalStructures = response.data;
        this.loadStructures();
      });
    },
    clean() {
      var bodyFormData = new FormData();
      bodyFormData.append('confirmationCode', this.confirmationCode);
      axios.post('api/admin/structures/clean', bodyFormData).then(response => {
        this.structures = [];
        this.hydrated = false;
        this.totalStructures = 0;
        start = 0;
        this.loadData();
      })
    },
    makeToast(message) {
      toast.success(message);
    },
    loadStructures() {
      const remaining = this.totalStructures - start;
      const end = remaining > batchSize ? start + batchSize : start + remaining;
      axios.get('/api/admin/structures?' + new URLSearchParams({
        start: start,
        end: end
      })).then((response) => {
        this.structures = this.structures.concat(response.data);
        start += batchSize;

        if (start < this.totalStructures) {
          this.loadData();
        } else {
          this.hydrated = true;
        }
      });
    }
  },
};
</script>

